import { mergeStyles, Stack, useTheme } from '@fluentui/react';
import React from 'react';
import { BaseComponentProps, Input } from '../types';
import { buttonGroupStyles } from './ButtonGroupStyles';

export const ButtonGroup = (props: BaseComponentProps & { underline?: boolean }): JSX.Element => {
  const { inputs, onSubmit, underline } = props;
  const theme = useTheme();
  const styles = buttonGroupStyles(theme);

  const handleSubmit = (inputs: Input) => {
    onSubmit && onSubmit([inputs]);
  };

  return (
    <Stack styles={{ root: styles.buttonGroupRoot }}>
      <ul className={mergeStyles(styles.list)}>
        {inputs.map((input) => (
          <li
            key={input.id}
            className={mergeStyles(styles.button)}
            onClick={() => handleSubmit(input)}
          >
            <Stack style={{ textDecoration: underline ? 'underline' : 'none' }}>{input.name}</Stack>
          </li>
        ))}
      </ul>
    </Stack>
  );
};
